export default __webpack_public_path__ + "images/6P.27b6cba.png";